import axios from 'axios'

// create an axios instance
const service = axios.create({
  timeout: 600000, // request timeout
  withCredentials: true,
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log('-0-0-0-0-0-0-0-0-0---config',config)
    // 统一在这里给url加时间戳
    if(config.url.indexOf('?') > -1 && config.url.indexOf('&t=' == -1)){
      const time = Number(new Date())
      config.url = config.url + '&t=' + time
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js